import { css, styled } from 'styled-components';
import { Media } from '../../../theme/Media.js';
import { CONTAINER_MAX_WIDTH_CSS, CONTAINER_PADDING_SM_MAX_CSS, CONTAINER_PADDING_SM_MIN_CSS } from './constants.js';
import { getGridLayoutStyles } from './gridStyles.js';
import { ContainerLayout } from './types.js';
export const StyledContainer = styled.div `
  width: 100%;
  box-sizing: border-box;

  @media ${Media.smMin} {
    padding: 0 ${CONTAINER_PADDING_SM_MIN_CSS};
  }

  @media ${Media.xsMax} {
    padding: 0 ${CONTAINER_PADDING_SM_MAX_CSS};
  }

  ${({ $spacer }) => $spacer &&
    css `
      margin-bottom: 24px;
    `}

  ${({ $fluid }) => !$fluid &&
    css `
      max-width: ${CONTAINER_MAX_WIDTH_CSS};
      margin-left: auto;
      margin-right: auto;
    `}

  ${({ $layout }) => $layout === ContainerLayout.Vertical &&
    css `
      display: flex;
      flex-direction: column;

      @media ${Media.mdMin} {
        gap: 24px;
      }

      @media ${Media.smMax} {
        gap: 8px;
      }
    `}

  ${({ $layout }) => $layout !== undefined &&
    $layout !== ContainerLayout.Vertical &&
    css `
      display: grid;
      align-items: flex-start;
      ${getGridLayoutStyles($layout)}

      > * {
        min-width: 0;
      }
    `}
`;
